"use strict";
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetGuildService = void 0;
const app_consensus_1 = require("@branch-ts/app-consensus");
const cas_1 = require("@branch-ts/cas");
const idps_consensus_1 = require("@branch-ts/idps-consensus");
const lifespan_consensus_1 = require("@branch-ts/lifespan-consensus");
const guildExplorer_1 = require("@branch-ts/practice-idps-web/src/guild/guildExplorer/guildExplorer");
const seqop_consensus_1 = require("@branch-ts/seqop-consensus");
const web_consensus_1 = require("@branch-ts/web-consensus");
const verset_consensus_1 = require("@project/verset_consensus");
const service_VersetRequireLogin_1 = require("./service.VersetRequireLogin");
let VersetGuildService = (() => {
    let _classDecorators = [(0, app_consensus_1.service)()];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    var VersetGuildService = class {
        static { _classThis = this; }
        constructor() {
            this.me = app_consensus_1.ServiceContext.about(this);
            this.deps = this.me.dependencies({
                VersetRequireLoginService: service_VersetRequireLogin_1.VersetRequireLoginService,
            });
            this.lifespan = lifespan_consensus_1.LifespanMechanism.about(this);
            this.llmSpec = { iterators: {}, variants: {} };
        }
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
            __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
            VersetGuildService = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
            __runInitializers(_classThis, _classExtraInitializers);
        }
        get agreement() {
            return this.deps.VersetRequireLoginService.agreement;
        }
        get editorKind() {
            return this.agreement.particulars.versetWebapp.idps.editorKind;
        }
        get server() {
            return this.deps.VersetRequireLoginService.server;
        }
        get rpc() {
            return this.server.rpcs.VersetUserGuildService;
        }
        async refreshLLMSpec() {
            const [catalog, reason, ...errors] = await this.server.rpcs.VersetUserLLMRouteService.getMyAvailableIterators();
            if (reason)
                throw new Error([reason, ...errors.map(error => error.message)].join(" "));
            this.llmSpec = { iterators: Object.fromEntries(catalog.iterators.map(iterator => [iterator.id, iterator])), variants: {} };
        }
        async initialize() {
            const vendor = this.me.app.vendor;
            idps_consensus_1.GuildAmbientContextMechanism.register({
                name: `${vendor}+guild-ambient+verset`,
                cache: false,
                registry: ({ uri }) => idps_consensus_1.GuildProtocol.GuildURI.parse(uri)?.vendor === vendor
                    ? new idps_consensus_1.GuildAmbientContext({ spec: this.llmSpec, defaultHeroWareURIs: (0, idps_consensus_1.getRegisteredBuiltInShellwareURIs)({ vendor }), shellwareVariants: [] })
                    : null,
            });
            this.registerGuildMediator(vendor);
            web_consensus_1.PuriAppMechanism.register({
                name: "VersetGuildExplorer",
                registry: (option) => {
                    const guildInfo = idps_consensus_1.GuildProtocol.GuildURI.parse(option.uri);
                    if (!guildInfo || guildInfo.vendor !== vendor) {
                        return null;
                    }
                    return this.createGuildExplorer({
                        uri: option.uri,
                    });
                },
            });
            for (const kind of ["guild+idps", "guild+hero", "guild+solution"]) {
                cas_1.PuriRuneConceptMechanism.packageOf(this.editorKind).register({
                    kind,
                    trigger: (option) => {
                        web_consensus_1.UIMechanism.goto({
                            uri: option.uri,
                        });
                        return true;
                    },
                });
            }
            web_consensus_1.UIMechanism.registerAppURIResolver({
                resolver: (option) => {
                    const guildInfo = idps_consensus_1.GuildProtocol.GuildURI.parse(option.uri);
                    if (!guildInfo || guildInfo.vendor !== vendor) {
                        return false;
                    }
                    const app = web_consensus_1.PuriAppMechanism.ensure({
                        uri: option.uri,
                    });
                    if (!app) {
                        return false;
                    }
                    const win = new web_consensus_1.WindowBehavior(app, {
                        intrinsicSize: {
                            width: 1120,
                            height: 760,
                        },
                        minSize: {
                            width: 760,
                            height: 520,
                        },
                    });
                    win.setTitle(`${verset_consensus_1.VersetProtocol.ProductName.guild} Explorer`);
                    void win.show();
                    return true;
                },
            });
        }
        registerGuildMediator(vendor) {
            seqop_consensus_1.MediatorRegistryMechanism.register({
                name: `${vendor}+guild+verset`,
                registry: (option) => {
                    const guildInfo = idps_consensus_1.GuildProtocol.GuildURI.parse(option.uri);
                    if (!guildInfo || guildInfo.vendor !== vendor || this.lifespan.isDestroyed)
                        return null;
                    const provider = new seqop_consensus_1.ReconnectingArbitratorProvider(async () => {
                        const [result, reason, ...errors] = await this.getGuildProvider({ uri: option.uri });
                        if (reason || !result?.provider)
                            throw new Error(reason || errors?.[0]?.message || "Failed to get guild provider");
                        return result.provider;
                    }, this.server.authorizedConnection);
                    const mediator = new idps_consensus_1.GuildMediator({ arbitrator: provider, uri: option.uri });
                    mediator.shouldCacheLocally = true;
                    // Guild data belongs to the signed-in runtime, not its explorer.
                    mediator.lifespanAware.lifespan.retain(this.lifespan);
                    return provider.own(mediator);
                },
            });
        }
        async resolveIteratorAvailable() {
            const [result] = await this.server.rpcs.VersetUserLLMRouteService.getMyAvailableIterators();
            return result?.iterators.map(({ id }) => id) || [];
        }
        createGuildExplorer(option) {
            const guildExplorer = new guildExplorer_1.GuildExplorer();
            void this.configureGuildExplorer({
                guildExplorer,
                uri: option.uri,
            });
            return guildExplorer;
        }
        async configureGuildExplorer(option) {
            await this.refreshLLMSpec();
            await option.guildExplorer.present.configure({
                uri: option.uri,
                editorKind: this.editorKind,
            });
        }
        async getOrCreateMyGuildURI() {
            await this.refreshLLMSpec();
            const [listed, listedReason, ...listedErrors] = await this.listMyGuilds({
                offset: 0,
                count: 1,
            });
            if (listedReason) {
                throw new Error(listedReason || listedErrors?.[0]?.message || "Failed to list user guilds");
            }
            const existing = listed?.items?.[0]?.uri;
            if (existing) {
                return existing;
            }
            const [created, createdReason, ...createdErrors] = await this.createGuild({
                name: `My ${verset_consensus_1.VersetProtocol.ProductName.guild}`,
                description: "Verset AI team",
            });
            if (createdReason || !created?.uri) {
                throw new Error(createdReason || createdErrors?.[0]?.message || "Failed to create user guild");
            }
            return created.uri;
        }
        async configureMyGuildExplorer(option) {
            const uri = await this.getOrCreateMyGuildURI();
            await this.configureGuildExplorer({
                guildExplorer: option.guildExplorer,
                uri,
            });
        }
        async createGuild(option) {
            return await this.rpc.createGuild(option);
        }
        async getGuild(option) {
            return await this.rpc.getGuild(option);
        }
        async listMyGuilds(option = {}) {
            return await this.rpc.listMyGuilds(option);
        }
        async getGuildProvider(option) {
            return await this.rpc.getGuildProvider(option);
        }
        destroy() {
            this.lifespan.destroy();
        }
    };
    return VersetGuildService = _classThis;
})();
exports.VersetGuildService = VersetGuildService;
